<template>
    <div class="term-wrap">
        <input v-model="value" :id="id" type="checkbox" />
        <label class="checkboxLabel" :for="id">
            <slot></slot>
        </label>
    </div>
</template>

<script>
    export default {
        name: "term",
        props: ['id', 'val'],
        mounted: function () {
            this.value = this.val;
        },
        data: function () {
            return {
                value: false
            }
        },
        watch: {
            val: function () {
              this.value = this.val;
            },
            value: function () {
                this.$emit('input', this.value);
            }
        }
    }
</script>

<style scoped lang="scss">

</style>